import BaseServices from "./BaseServices";

const EmbroideryServices = {
    //#region Máy thêu
    GetMachines: async (paging) => {
        return BaseServices.Post(`/api/Embroidery/get-machines`, paging);
    },
    GetMachineById: async (id) => {
        return BaseServices.Get(`/api/Embroidery/get-machine/${id}`);
    },
    CreateUpdateMachine: async (model) => {
        return BaseServices.Post(`/api/Embroidery/create-update-machine`, model);
    },
    DeleteMachine: async (id) => {
        return BaseServices.Post(`/api/Embroidery/delete-machine/${id}`);
    },
    //#endregion

    //#region Màu chỉ
    GetThreadColors: async (paging) => {
        return BaseServices.Post(`/api/Embroidery/get-thread-colors`, paging);
    },
    GetThreadColorDropdown: async (onlyActive = true) => {
        return BaseServices.Get(`/api/Embroidery/get-thread-color-dropdown?onlyActive=${onlyActive}`);
    },
    CreateUpdateThreadColor: async (model) => {
        return BaseServices.Post(`/api/Embroidery/create-update-thread-color`, model);
    },
    DeleteThreadColor: async (id) => {
        return BaseServices.Post(`/api/Embroidery/delete-thread-color/${id}`);
    },
    //#endregion

    //#region Kim - needle bar
    GetNeedleBarsByMachineId: async (machineId) => {
        return BaseServices.Get(`/api/Embroidery/get-needle-bars/${machineId}`);
    },
    SaveNeedleBars: async (machineId, needleBars) => {
        return BaseServices.Post(`/api/Embroidery/save-needle-bars/${machineId}`, needleBars);
    },
    //#endregion

    //#region File thêu
    GetDesignFiles: async (paging) => {
        return BaseServices.Post(`/api/Embroidery/get-design-files`, paging);
    },
    GetDesignFileById: async (id) => {
        return BaseServices.Get(`/api/Embroidery/get-design-file/${id}`);
    },
    CreateUpdateDesignFile: async (model) => {
        return BaseServices.Post(`/api/Embroidery/create-update-design-file`, model);
    },
    DeleteDesignFile: async (id) => {
        return BaseServices.Post(`/api/Embroidery/delete-design-file/${id}`);
    },
    //#endregion

    //#region Manifest + thứ tự đổi màu
    SaveManifests: async (designFileId, manifests) => {
        return BaseServices.Post(`/api/Embroidery/save-manifests/${designFileId}`, manifests);
    },
    SaveColorChangeSequences: async (designFileId, sequences) => {
        return BaseServices.Post(`/api/Embroidery/save-color-change-sequences/${designFileId}`, sequences);
    },
    GetColorChangeSequences: async (designFileId) => {
        return BaseServices.Get(`/api/Embroidery/get-color-change-sequences/${designFileId}`);
    },
    //#endregion

    //#region Họa tiết thêu (pattern)
    GetPatterns: async (paging) => {
        return BaseServices.Post(`/api/Embroidery/get-patterns`, paging);
    },
    GetPatternById: async (id) => {
        return BaseServices.Get(`/api/Embroidery/get-pattern/${id}`);
    },
    CreateUpdatePattern: async (model) => {
        return BaseServices.Post(`/api/Embroidery/create-update-pattern`, model);
    },
    DeletePattern: async (id) => {
        return BaseServices.Post(`/api/Embroidery/delete-pattern/${id}`);
    },
    //#endregion
};

export default EmbroideryServices;
